import { render, staticRenderFns } from "./RundownCard.vue?vue&type=template&id=ede183f0&"
import script from "./RundownCard.vue?vue&type=script&lang=js&"
export * from "./RundownCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports